import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0018f510"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "report-search",
  class: "sr-only"
}, "Search", -1))
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-btn ml-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-outline-primary custom-white-button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1))

import { ref, onMounted, inject,watch, onBeforeUnmount, onUnmounted } from 'vue';
import Ably from "ably";
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByString',
  props: {
    placeholder: {},
    showserachresulttable: { type: Boolean }
  },
  emits: ['searchsubmit'],
  setup(__props: any, { emit: __emit }) {

const realtime: Ably.Realtime = inject('realtime');
const actProperty: any = inject('actProperty');
const route = useRoute();

const props = __props;

const searchvalue = ref('');
const searchinput = ref(null);

const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();
const emits = __emit;

const onSubmit = () => {
  emits('searchsubmit', searchvalue.value);
  channel.publish('appointmentSearch', { deviceid: deviceid, searchtext: searchvalue.value });
};

watch(() => route.params.id, async (id: string) => {
  searchinput.value.focus();
});

onMounted(() => {
  channel.subscribe('appointmentSearch', (message: any) => {
    if (props.showserachresulttable && message?.data) {
      if (message.data.deviceid !== deviceid) return;
      if (message.data.searchtext && searchvalue.value !== message.data.searchtext) {
        searchvalue.value = message.data.searchtext;
        emits('searchsubmit', searchvalue.value);
      }
    }
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe('appointmentSearch');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "report-search",
        type: "search",
        class: "form-control searchbar",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchvalue).value = $event)),
        ref_key: "searchinput",
        ref: searchinput,
        placeholder: _ctx.placeholder,
        autocomplete: "off"
      }, null, 8, _hoisted_3), [
        [_vModelText, searchvalue.value]
      ]),
      _hoisted_4
    ])
  ], 32))
}
}

})